import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API = process.env.REACT_APP_BACKEND_URL;
const NONE = '__none__';

export const OfferDeptCompanyFields = ({ formData, setFormData }) => {
  const [depts, setDepts] = useState([]);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/departments`).then(r => setDepts((r.data || []).map(d => d.department).filter(Boolean))).catch(() => {});
    axios.get(`${API}/api/company-assets/companies`).then(r => setCompanies(r.data || [])).catch(() => {});
  }, []);

  const field = (key, label, options, testId) => (
    <div>
      <Label>{label} <span className="text-[11px] text-gray-400">(optional)</span></Label>
      <Select value={formData[key] || NONE} onValueChange={v => setFormData(p => ({ ...p, [key]: v === NONE ? '' : v }))}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder={`Select ${label.toLowerCase()}`} /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>-- None --</SelectItem>
          {[...new Set([...options, formData[key]].filter(Boolean))].map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );

  return (
    <div className="grid grid-cols-2 gap-4">
      {field('department', 'Department', depts, 'offer-department-select')}
      {field('company', 'Company', companies, 'offer-company-select')}
    </div>
  );
};
